import Vue from "vue";
import Vuex from "vuex";
import router from "@/router";
import { userInfoApi } from "@/api/user";
import { pcAdApi, pcConfigApi } from "@/api/home";

Vue.use(Vuex);

// 从localStorage初始化状态
const initState = () => {
  const token = localStorage.getItem("mall_token") || "";
  let userInfo = {};
  try {
    const userInfoStr = localStorage.getItem("mall_userInfo");
    userInfo = userInfoStr ? JSON.parse(userInfoStr) : {};
  } catch (error) {
    console.error("解析用户信息失败:", error);
  }
  return { token, userInfo };
};

export default new Vuex.Store({
  state: {
    token: initState().token,
    userInfo: initState().userInfo,
    config: {},
  },
  getters: {
    token: (state) => state.token,
    userInfo: (state) => state.userInfo,
    config: (state) => state.config,
  },
  mutations: {
    SETTOKEN(state, token) {
      state.token = token;
      localStorage.setItem("mall_token", token);
    },
    SETUSERINFO(state, userInfo) {
      state.userInfo = userInfo;
      localStorage.setItem("mall_userInfo", JSON.stringify(userInfo));
    },
    WEBCONFIG(state, info) {
      state.config = info;
    },
  },
  actions: {
    setToken: async ({ commit }, value) => {
      commit("SETTOKEN", value);
    },
    setUserInfo: async ({ commit }, value) => {
      commit("SETUSERINFO", value);
    },

    // 初始化用户信息 - 从localStorage恢复并验证
    initUserInfo: async ({ commit, state }) => {
      // 如果有token，尝试从API获取最新用户信息
      if (state.token) {
        try {
          const res = await userInfoApi();
          commit("SETUSERINFO", res.data);
          return res.data;
        } catch (error) {
          console.error("获取用户信息失败:", error);
          // 如果API失败，保持localStorage中的信息
        }
      }
      return state.userInfo;
    },

    //获取用户信息
    getUserInfo: async ({ commit }, value) => {
      return new Promise((resolve, reject) => {
        userInfoApi()
          .then((res) => {
            commit("SETUSERINFO", res.data);
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    //获取首页广告配置
    getPcConfigApi: async ({ commit }, value) => {
      return new Promise((resolve, reject) => {
        pcConfigApi().then((res) => {
          commit("WEBCONFIG", JSON.parse(res.data || "{}"));
          resolve(JSON.parse(res.data || "{}"));
        });
      });
    },

    //退出登录
    logOut: ({ commit }, value) => {
      commit("SETTOKEN", "");
      commit("SETUSERINFO", {});
      localStorage.removeItem("mall_token");
      localStorage.removeItem("mall_userInfo");
      router.push("/");
    },
  },
  modules: {},
});
